import React from 'react'
import classes from './GameList.module.css'
import { Link } from 'react-router-dom'

const GameList = ({data}) => {
    console.log(data)
  return (
    <div className={classes.container}>
    <div className={classes.list}>
        {
            data?.map((item,idx)=>(
                <>
                <div className=" relative mb-30 w-[100%]" >
                  <div className="latest-games-thumb h-[15rem] w-[100%] rounded-md ">
                    <a href={item?.game}>
                      <img
                        src={item?.image}
                        alt="Game SRC"
                       
                        className='rounded-lg h-full w-full'
                      />
                    </a>
                  </div>
                  <div className="latest-games-content rounded-lg w-[100%]">
                    <div className="lg-tag">
                      <a href={`${item?.game}`} >Play</a>
                    </div>
                    <p>
                      {item.name}
                      {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. */}
                    </p>
                  </div>
                </div> 
                </>
            ))
        }
    </div>
    </div>
  )
}

export default GameList
